export function init() {
    const serviceMessage = $('.service-message');
    const serviceMessageContentBox = $('.service-message__content');

    serviceMessageContentBox.click(function () {
        const dropdown = $('.service-message__dropdown');

        dropdown.slideToggle();
        serviceMessage.toggleClass('open');
    });
}

export default {
    init
};
